// The code is automatically generated
import * as React from "react";
import Icon from "@ant-design/icons";
import Svg from "./chevronDown";
export default (props) => <Icon component={Svg} {...props} style={{ fontSize: 24, ...props.style }} />;
